import {pageInfo, initUpdate, editData, cancleOrder, exportData, selectTotalProfit, initPage} from './../api';
import {getExpensesAreasOptionInfo, market, marketTravelAgency, orderUserNo, selectTravelStatus} from "../../../../api";
const orderSearch = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    deleteResp: null,
    initPageObj: null,
    initUpdateObj: null,
    carrierInfoObj: null,
    cancleObj: null,
    travelStatusObj: null,
    expensesAreasOptionObj: null,
    exportObj: null,
    totalProfitObj: null,
    orderUserNoObj: null
  },
  mutations: {
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj
    },
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj.map(item=> ({
          ...item,
          btns:[
            true,{disabled: item.travelStatusNo == 'TS000' || item.orderLocked == 'Y' || item.receivablesCheckFlag == 'Y' || item.totalProfitCheckFlag == 'Y' ? true : false},
            item.travelStatusNo == 'TS000' || item.orderLocked == 'Y' || item.depositCheckFlag == 'Y' || item.receivablesCheckFlag == 'Y' || item.totalProfitCheckFlag == 'Y' ? false : true
          ]
        })
      );
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    },
    MARKET_DATA(state,data) {
      state.marketObj = data;
    },
    MARKET_TRAVEL_AGENCY_DATA(state,data) {
      state.marketTravelAgencyObj = data;
    },
    CANCLE_ORDER_DATA(state,data) {
      state.cancleObj = data;
    },
    TRAVEL_STATUS_DATA(state,data) {
      state.travelStatusObj = data;
    },
    EXPENSES_AREAS_OPTION_DATA(state,data) {
      state.expensesAreasOptionObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    SELECT_TOTAL_PROFIT_DATA(state, data) {
      state.totalProfitObj = data;
    },
    ORDER_USERNO_DATA(state, data) {
      state.orderUserNoObj = data;
    },
  },
  actions: {
    //初始化
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化更新对象事件
    async editDetails({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //市场下拉框
    async market({commit}, obj){
      let resp = await market(obj);
      commit('MARKET_DATA', resp);
    },
    //地接社下拉框
    async marketTravelAgency({commit}, obj){
      let resp = await marketTravelAgency(obj);
      commit('MARKET_TRAVEL_AGENCY_DATA', resp);
    },
    //行程状态下拉框
    async selectTravelStatus({commit}, obj){
      let resp = await selectTravelStatus(obj);
      commit('TRAVEL_STATUS_DATA', resp);
    },
    //业务员下拉框
    async selectOrderUserNo({commit}, obj){
      let resp = await orderUserNo(obj);
      commit('ORDER_USERNO_DATA', resp);
    },
    //根据市场ID查询地接社
    async getExpensesAreasOptionInfo({commit}, obj){
      let resp = await getExpensesAreasOptionInfo(obj);
      commit('EXPENSES_AREAS_OPTION_DATA', resp);
    },
    //取消
    async cancleOrder({commit}, obj){
      let resp = await cancleOrder(obj);
      commit('CANCLE_ORDER_DATA', resp);
    },
    //导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //查询总利润
    async selectTotalProfit({ commit }, obj) {
      let resp = await selectTotalProfit(obj);
      commit('SELECT_TOTAL_PROFIT_DATA', resp);
    },
  }
}
export default orderSearch



// WEBPACK FOOTER //
// ./src/page/zhubo/orderQuery/store/orderQuery.store.js